import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
import BodyModule from "../store/modules/BodyModule";
import BreadcrumbsModule from "../store/modules/BreadcrumbsModule";
import ConfigModule from "../store/modules/ConfigModule";
// import createPersistedState from "vuex-persistedstate";

config.rawError = true;
const store = createStore({
  modules: {
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
  },
  plugins: [
    // createPersistedState({
    //   paths: [],
    //   storage: window.sessionStorage,
    //   reducer(state) {
    //     return {};
    //   },
    // }),
  ],
});

export default store;
